<template>
  <div class="divide-y divide-gray-200">
    <section v-for="(section, index) in config"
      class="p-4"
      :key="index"
      :class="(section.onReady && !loadingColors) || (!section.onReady && !loading) ? 'disable-ske' : ''"
    >
      <h3 class="text-lg font-semibold flex justify-between">
        {{ section.title }}
        <button v-if="index === 0" class="hover:bg-gray-50 duration-150 p-1 px-2 border border-gray-200 rounded-lg space-x-2 flex items-center" @click="$emit('reset-changes')">
          <span class="!text-sm">
            {{ isOverwritting ? "Reset to global values" : "Reset color changes" }}
          </span>
        </button>
        <button v-else class="hover:bg-gray-50 duration-150 p-1 px-2 border border-gray-200 rounded-lg space-x-2 flex items-center" @click="$emit('reset-tailwind-changes')">
          <span class="!text-sm">
            {{ isOverwritting ? "Reset to global values" : "Reset base" }}
          </span>
        </button>
      </h3>

      <ColorsList
        v-if="section.fields && section.fields.length"

        ref="section"
        class="relative z-10"
        :ready="ready"
        :section="section"
        :isOverwritting="isOverwritting"
        :vuelidate="vuelidate[section.id]"

        @updated="$emit('updated')"
        @refetch-blocks="$emit('refetch-blocks')"
        @remove-field="id => $emit('remove-field', id)"
      />
      <div v-else-if="section.sub_sections && section.sub_sections.length" class="space-y-2 pt-2 relative z-0">
        <div v-for="(sub, index) in section.sub_sections"
          class="flex space-x-2"
          :key="index"
        >
          <h2 v-if="sub.title" class="text-base w-20 shrink-0 font-medium"><span class="ske">{{ sub.title }}</span></h2>
          <ColorsList

            ref="section"
            class="-mt-2"
            :ready="ready"
            :section="sub"
            :isOverwritting="isOverwritting"
            :vuelidate="vuelidate[section.id]"

            @updated="$emit('updated')"
            @refetch-blocks="$emit('refetch-blocks')"
            @remove-field="id => $emit('remove-field', id)"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import ColorsList from "./ColorsList.vue"

import { mapGetters } from "vuex"

export default {
  components: {
    ColorsList,
  },
  props: ['config', 'vuelidate', 'loadingColors', 'isOverwritting'],
  methods: {
    update() {
      this.$refs['section'].forEach(vm => vm.$forceUpdate())
    },
  },
  computed: {
    ...mapGetters({
      ready: "editor/ready",
      loading: "editor/loading",
    })
  },
}

</script>
